var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"submit","title":"Szukaj","ceid":"Wyszukiwarka - szukaj"}},[_vm._v("\n    Szukaj w Castorama...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }